import { useEffect, useState } from "react";

export default function useAppendJs() {
  const [scriptToInsert, setScriptToInsert] = useState(null);

  useEffect(() => {
    const tag = document.createElement("script");
    tag.innerHTML = scriptToInsert;
    tag.async = true;
    document.body.appendChild(tag);
    return () => {
      document.body.removeChild(tag);
    };
  }, [scriptToInsert]);

  function appendJs(script) {
    setScriptToInsert(script);
  }

  return appendJs;
}
